import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../store/userSlice";
import { loginUser } from "../api/auth";
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Layout,
  message,
  Checkbox,
  Alert,
} from "antd";
import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import logo from "../assets/images/logo.png";
import logo1 from "../assets/images/LOGOS-03.png";

const { Title, Text } = Typography;
const { Content } = Layout;

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onFinish = async (values) => {
    setLoading(true);
    setError("");
    try {
      const data = await loginUser(values.username, values.password);
      if (values.remember) {
        localStorage.setItem("rememberedUsername", values.username);
      } else {
        localStorage.removeItem("rememberedUsername");
      }
      dispatch(login(data));
      message.success("Bienvenue de nouveau !");

      navigate("/dashboard");
    } catch (err) {
      setError(
        "Nom d'utilisateur ou mot de passe incorrect. Veuillez réessayer."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="min-h-screen bg-gradient-to-br from-purple-50 to-purple-100">
      <Content className="flex items-center justify-center p-4 sm:p-8">
        <Card
          className="w-full max-w-md shadow-xl rounded-lg border-0"
          styles={{ padding: "2rem" }}
        >
          <div className="mb-8 text-center space-y-4">
            <img
              src={logo1}
              alt="Logo de l'entreprise"
              className="mx-auto h-32 w-auto hover:scale-105 transition-transform duration-300"
            />
            <Title level={2} className="m-0 !text-gray-800">
              Bienvenue !
            </Title>
          </div>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              className="mb-6"
              onClose={() => setError("")}
            />
          )}

          <Form
            form={form}
            name="login"
            initialValues={{
              remember: true,
              username: localStorage.getItem("rememberedUsername") || "",
            }}
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Veuillez entrer votre nom d'utilisateur !",
                },
                {
                  min: 3,
                  message:
                    "Le nom d'utilisateur doit comporter au moins 3 caractères",
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="text-gray-400" />}
                placeholder="Nom d'utilisateur"
                className="rounded-lg"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Veuillez entrer votre mot de passe !",
                },
              ]}
              className="mb-2"
            >
              <Input.Password
                prefix={<LockOutlined className="text-gray-400" />}
                placeholder="Mot de passe"
                className="rounded-lg"
              />
            </Form.Item>

            <div className="flex justify-between items-center mb-6">
              <Form.Item
                name="remember"
                valuePropName="checked"
                className="mb-0"
              >
                <Checkbox>Se souvenir de moi</Checkbox>
              </Form.Item>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-12 rounded-lg"
                loading={loading}
                icon={<LoginOutlined />}
              >
                Connexion
              </Button>
              {process.env.REACT_APP_VERSION}
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
}
